import { render, staticRenderFns } from "./ImportMediaFile.vue?vue&type=template&id=b4834e92&"
import script from "./ImportMediaFile.vue?vue&type=script&lang=js&"
export * from "./ImportMediaFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports